import script from "./Gynecology.vue?vue&type=script&setup=true&lang=js"
export * from "./Gynecology.vue?vue&type=script&setup=true&lang=js"

import "./Gynecology.vue?vue&type=style&index=0&id=ba1a742c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba1a742c"]])

export default __exports__